import { gql } from "@apollo/client";

export const RETRY_PREPAID_SYNC = gql`
  mutation RetryPrepaidSync($id: ID!) {
    retryPrepaidSync(id: $id) {
      _id
    }
  }
`;
